import React from 'react';

import { getApolloClient } from '@confluence/graphql';
import { useNativeCollabState } from '@confluence/native-collab';
import { useContentAppearance } from '@confluence/content-appearance';

import { EditorAppearanceButtonComponent } from './EditorAppearanceButtonComponent';
import type { UpdateContentAppearancePropertyBody } from './types';
import { UpdateContentAppearancePropertyMutation } from './UpdateContentAppearancePropertyMutation.experimentalgraphql';

type EditorAppearanceButtonNextProps = {
	contentId: string;
	isStatusDisconnected: boolean;
	disabled?: boolean;
};
export const EditorAppearanceButtonNext = ({
	contentId,
	isStatusDisconnected,
	disabled = false,
}: EditorAppearanceButtonNextProps) => {
	const { contentAppearance, setContentAppearance, contentAppearanceLoading } =
		useContentAppearance();

	const [{ collabEditProvider, collabEditInitialized }] = useNativeCollabState();
	const updateContentAppearanceProperty = async (
		params: UpdateContentAppearancePropertyBody,
	): Promise<void> => {
		const client = getApolloClient();
		const payload = {
			contentId: params.contentId,
			propertyKey: params.propertyKey,
			propertyValue: params.propertyValue,
			versionNumber: params.versionNumber.toString(),
			isDelete: false,
		};
		const result = await client.mutate({
			mutation: UpdateContentAppearancePropertyMutation,
			variables: payload,
		});

		if (result?.data?.experimentalUpdateContentProperty?.success) {
			setContentAppearance({
				appearance: params.propertyValue,
				version: params.versionNumber,
			});
		}
	};

	const isDisabled = contentAppearanceLoading || !collabEditInitialized || disabled;

	return (
		<EditorAppearanceButtonComponent
			contentId={contentId}
			collabEditProvider={collabEditProvider}
			isDisabled={isDisabled}
			isStatusDisconnected={isStatusDisconnected}
			updateContentAppearanceProperty={updateContentAppearanceProperty}
			contentAppearanceDraft={contentAppearance}
		/>
	);
};
